export const BOOK_EVENT = "dn-open-calendly";
const STORAGE_KEY = "dn-open-calendly";

export function requestBookCall(navigate) {
  try {
    sessionStorage.setItem(STORAGE_KEY, "1");
  } catch (error) {
    // Storage can be blocked. The event still opens the calendar on this page.
  }

  if (window.location.pathname === "/") {
    window.dispatchEvent(new Event(BOOK_EVENT));
    document.getElementById("book-appointment")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
    return;
  }

  if (navigate) {
    navigate("/#book-appointment");
    return;
  }

  window.location.assign("/#book-appointment");
}

export function consumeBookRequest() {
  try {
    if (sessionStorage.getItem(STORAGE_KEY) === "1") {
      sessionStorage.removeItem(STORAGE_KEY);
      return true;
    }
  } catch (error) {
    return false;
  }
  return false;
}
